module.exports = __webpack_public_path__ + "img/09.f74c3fba.jpg";